import { Show } from 'solid-js'
import { authMe } from '../store/auth.ts'
import { Button } from './ui/Button.tsx'

export function LoginPage() {
  return (
    <div class="h-full flex flex-col items-center justify-center gap-4 px-4">
      <div class="flex items-center gap-2">
        <div class="i-lucide-search-code size-5 text-muted-foreground" />
        <span class="text-sm font-bold">codesearch</span>
      </div>

      <Show
        when={authMe()?.oidcEnabled}
        fallback={<div class="text-sm text-muted-foreground">authentication is misconfigured, check the server logs</div>}
      >
        <Button
          class="gap-2"
          onClick={() => {
            location.href = '/api/auth/login'
          }}
        >
          <div class="i-lucide-log-in size-4" />
          Log in
        </Button>
      </Show>
    </div>
  )
}
